import $http from "../services/AxiosInstance";
import { Routes } from "@services/utils/Routes";
import { IAgentsResponse, IAgents } from "../types/agents.type";

interface Params {
  page?: number;
  search?: string;
  deleted?: boolean;
}

class AgentsDataProviderRepository {
  async createAgent(agents: IAgents): Promise<IAgentsResponse> {
    try {
      if (!agents.name || agents.name.trim() === '') {
        return {
          errores: true,
          errors: [{ msg: "El nombre del agente es requerido" }],
          message: "Validación fallida"
        }
      }
      if (!agents.email || agents.email.trim() === '') {
        return {
          errores: true,
          errors: [{ msg: "El email del agente es requerido" }],
          message: "Validación fallida"
        }
      }
      if (!agents.rfc || agents.rfc.trim() === '') {
        return {
          errores: true,
          errors: [{ msg: "El RFC del agente es requerido" }],
          message: "Validación fallida"
        }
      }
      return await $http.post(Routes.AGENTES.INDEX, agents);
    } catch (error: any) {
      return {
        errores: true,
        errors: error?.errors ?? [],
        message: error?.message ?? null
      }
    }
  }
  
  async updateAgent(item: IAgents, id: number): Promise<IAgentsResponse> {
    try {
      if (!item.name || item.name.trim() === '') {
        return {
          errores: true,
          errors: [{ msg: "El nombre del agente es requerido" }],
          message: "Validación fallida"
        }
      }
      if (!item.email || item.email.trim() === '') {
        return {
          errores: true,
          errors: [{ msg: "El email del agente es requerido" }],
          message: "Validación fallida"
        }
      }
      if (!item.rfc || item.rfc.trim() === '') {
        return {
          errores: true,
          errors: [{ msg: "El RFC del agente es requerido" }],
          message: "Validación fallida"
        }
      }
      const response = await $http.patch(`${Routes.AGENTES.UPDATE}/${id}`, item);
      return response.data;
    } catch (error: any) {
      return {
        errores: true,
        errors: error?.errors ?? [],
        message: error?.message ?? null
      }
    }
  }
  
  async indexAgents(params: Params = {}): Promise<IAgentsResponse> {
    try {
      if (params.search && params.search.trim() === '') {
        params.search = undefined;
      }
      let url = `${Routes.AGENTES.INDEX}`;
      if (params.page) {
        url += `?page=${params.page}`;
      }
      if (params.search) {
        url += `${params.page ? '&' : '?'}search=${encodeURIComponent(params.search)}`;
      }
      if (params.deleted) {
        url += `${params.page || params.search ? '&' : '?'}deleted=${params.deleted}`;
      }
      const response = await $http.get(url);
      return response.data;
    } catch (errors: any) {
      return errors;
    }
  }

  async deleteAgent(id: number, restore: boolean): Promise<IAgents> {
    try {
      if (!id || id <= 0) {
        throw new Error("ID del agente inválido");
      }
      const response = !restore
        ? await $http.delete(`${Routes.AGENTES.DELETE}/${id}`)
        : await $http.patch(`${Routes.AGENTES.RESTORE}/${id}`);
      return response.data;
    } catch (errors: any) {
      return errors;
    }
  }
}

export default AgentsDataProviderRepository;
